import React from 'react';

export default function SetDueDate() {
  return (
    <svg
      width="89"
      height="89"
      viewBox="0 0 89 89"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        opacity="0.5"
        cx="44.4999"
        cy="44.4999"
        r="39.6977"
        fill="white"
      />
      <path
        opacity="0.4"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M45.5712 22.8376L38.9574 17.2258L40.8984 14.9383L45.3786 18.7398L49.0363 14.9919L53.3522 18.7408L57.1125 14.9928L61.3256 18.7416L65.1885 14.9934L69.299 18.742L73.3297 14.932L75.3904 17.1122L69.3356 22.8355L65.2523 19.1117L61.4141 22.8359L57.2291 19.1122L53.4926 22.8366L49.2061 19.1132L45.5712 22.8376Z"
        fill="#DDDBF9"
      />
      <path
        opacity="0.21"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M40.4715 62.8376L64.0708 75.6442L63.1169 77.4021L39.5176 64.5954L33.7666 80.2558C33.1873 81.8332 31.0388 82.0363 30.1742 80.5953L3.96522 36.9137L5.6802 35.8847L31.8892 79.5663L37.6402 63.906C38.0607 62.7609 39.3994 62.2558 40.4715 62.8376Z"
        fill="#B5B3C5"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M44.5 8C24.3416 8 8 24.3416 8 44.5C8 64.6584 24.3416 81 44.5 81C64.6584 81 81 64.6584 81 44.5C81 24.3416 64.6584 8 44.5 8ZM5 44.5C5 22.6848 22.6848 5 44.5 5C66.3152 5 84 22.6848 84 44.5C84 66.3152 66.3152 84 44.5 84C22.6848 84 5 66.3152 5 44.5Z"
        fill="#A7A5BA"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M88.5 44.5C88.5 68.8005 68.8005 88.5 44.5 88.5C20.1995 88.5 0.5 68.8005 0.5 44.5C0.5 20.1995 20.1995 0.5 44.5 0.5C68.8005 0.5 88.5 20.1995 88.5 44.5ZM44.5 82.5C65.4868 82.5 82.5 65.4868 82.5 44.5C82.5 23.5132 65.4868 6.5 44.5 6.5C23.5132 6.5 6.5 23.5132 6.5 44.5C6.5 65.4868 23.5132 82.5 44.5 82.5Z"
        fill="#E0DFE6"
      />
      <mask
        id="mask0_1_1364"
        maskUnits="userSpaceOnUse"
        x="27"
        y="28"
        width="34"
        height="33"
      >
        <path d="M27.2495 28H60.2495V61H27.2495V28Z" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1_1364)">
        <path
          d="M34.1245 58.25C33.3683 58.25 32.7206 57.981 32.1816 57.4429C31.6436 56.9039 31.3745 56.2563 31.3745 55.5V36.25C31.3745 35.4938 31.6436 34.8466 32.1816 34.3085C32.7206 33.7695 33.3683 33.5 34.1245 33.5H35.4995V30.75H38.2495V33.5H49.2495V30.75H51.9995V33.5H53.3745C54.1308 33.5 54.7784 33.7695 55.3174 34.3085C55.8555 34.8466 56.1245 35.4938 56.1245 36.25V55.5C56.1245 56.2563 55.8555 56.9039 55.3174 57.4429C54.7784 57.981 54.1308 58.25 53.3745 58.25H34.1245ZM34.1245 55.5H53.3745V41.75H34.1245V55.5ZM34.1245 39H53.3745V36.25H34.1245V39ZM43.7495 47.25C43.3599 47.25 43.0336 47.118 42.7705 46.854C42.5065 46.5909 42.3745 46.2646 42.3745 45.875C42.3745 45.4854 42.5065 45.1586 42.7705 44.8946C43.0336 44.6315 43.3599 44.5 43.7495 44.5C44.1391 44.5 44.4659 44.6315 44.7299 44.8946C44.993 45.1586 45.1245 45.4854 45.1245 45.875C45.1245 46.2646 44.993 46.5909 44.7299 46.854C44.4659 47.118 44.1391 47.25 43.7495 47.25ZM38.2495 47.25C37.8599 47.25 37.5331 47.118 37.2691 46.854C37.0061 46.5909 36.8745 46.2646 36.8745 45.875C36.8745 45.4854 37.0061 45.1586 37.2691 44.8946C37.5331 44.6315 37.8599 44.5 38.2495 44.5C38.6391 44.5 38.9659 44.6315 39.2299 44.8946C39.493 45.1586 39.6245 45.4854 39.6245 45.875C39.6245 46.2646 39.493 46.5909 39.2299 46.854C38.9659 47.118 38.6391 47.25 38.2495 47.25ZM49.2495 47.25C48.8599 47.25 48.5336 47.118 48.2705 46.854C48.0065 46.5909 47.8745 46.2646 47.8745 45.875C47.8745 45.4854 48.0065 45.1586 48.2705 44.8946C48.5336 44.6315 48.8599 44.5 49.2495 44.5C49.6391 44.5 49.9654 44.6315 50.2285 44.8946C50.4925 45.1586 50.6245 45.4854 50.6245 45.875C50.6245 46.2646 50.4925 46.5909 50.2285 46.854C49.9654 47.118 49.6391 47.25 49.2495 47.25ZM43.7495 52.75C43.3599 52.75 43.0336 52.618 42.7705 52.354C42.5065 52.0909 42.3745 51.7646 42.3745 51.375C42.3745 50.9854 42.5065 50.6591 42.7705 50.396C43.0336 50.132 43.3599 50 43.7495 50C44.1391 50 44.4659 50.132 44.7299 50.396C44.993 50.6591 45.1245 50.9854 45.1245 51.375C45.1245 51.7646 44.993 52.0909 44.7299 52.354C44.4659 52.618 44.1391 52.75 43.7495 52.75ZM38.2495 52.75C37.8599 52.75 37.5331 52.618 37.2691 52.354C37.0061 52.0909 36.8745 51.7646 36.8745 51.375C36.8745 50.9854 37.0061 50.6591 37.2691 50.396C37.5331 50.132 37.8599 50 38.2495 50C38.6391 50 38.9659 50.132 39.2299 50.396C39.493 50.6591 39.6245 50.9854 39.6245 51.375C39.6245 51.7646 39.493 52.0909 39.2299 52.354C38.9659 52.618 38.6391 52.75 38.2495 52.75ZM49.2495 52.75C48.8599 52.75 48.5336 52.618 48.2705 52.354C48.0065 52.0909 47.8745 51.7646 47.8745 51.375C47.8745 50.9854 48.0065 50.6591 48.2705 50.396C48.5336 50.132 48.8599 50 49.2495 50C49.6391 50 49.9654 50.132 50.2285 50.396C50.4925 50.6591 50.6245 50.9854 50.6245 51.375C50.6245 51.7646 50.4925 52.0909 50.2285 52.354C49.9654 52.618 49.6391 52.75 49.2495 52.75Z"
          fill="#7F77D9"
        />
      </g>
      <g opacity="0.3">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16.3105 40.0042C16.5867 40.0042 16.8105 40.228 16.8105 40.5042L16.8105 44.4999C16.8105 44.7761 16.5867 44.9999 16.3105 44.9999C16.0344 44.9999 15.8105 44.7761 15.8105 44.4999L15.8105 40.5042C15.8105 40.228 16.0344 40.0042 16.3105 40.0042Z"
          fill="#B5B3C5"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M18.8084 42.502C18.8084 42.7781 18.5846 43.002 18.3084 43.002L14.3126 43.002C14.0365 43.002 13.8126 42.7781 13.8126 42.502C13.8126 42.2258 14.0365 42.002 14.3126 42.002L18.3084 42.002C18.5846 42.002 18.8084 42.2258 18.8084 42.502Z"
          fill="#B5B3C5"
        />
      </g>
      <path
        opacity="0.6"
        d="M66.1495 53.282L67.2737 56.7003L70.692 57.8245L67.2737 58.9487L66.1495 62.3669L65.0253 58.9487L61.6071 57.8245L65.0253 56.7003L66.1495 53.282Z"
        fill="#B5B3C5"
      />
      <path
        opacity="0.34"
        d="M36.6882 22.324L37.312 24.2207L39.2087 24.8445L37.312 25.4682L36.6882 27.3649L36.0644 25.4682L34.1677 24.8445L36.0644 24.2207L36.6882 22.324Z"
        fill="#B5B3C5"
      />
      <path
        opacity="0.6"
        d="M65.2203 24.8445L66.0038 27.2266L68.3859 28.01L66.0038 28.7934L65.2203 31.1755L64.4369 28.7934L62.0548 28.01L64.4369 27.2266L65.2203 24.8445Z"
        fill="#BBB6F2"
      />
      <path
        d="M72.8995 40.5042C72.8995 41.1137 72.4053 41.6079 71.7957 41.6079C71.1861 41.6079 70.692 41.1137 70.692 40.5042C70.692 39.8946 71.1861 39.4004 71.7957 39.4004C72.4053 39.4004 72.8995 39.8946 72.8995 40.5042Z"
        fill="#D9D9D9"
      />
      <path
        d="M36.6882 75.8684C36.6882 76.478 36.1941 76.9722 35.5845 76.9722C34.9749 76.9722 34.4807 76.478 34.4807 75.8684C34.4807 75.2588 34.9749 74.7646 35.5845 74.7646C36.1941 74.7646 36.6882 75.2588 36.6882 75.8684Z"
        fill="#E0DFE6"
      />
    </svg>
  );
}
